import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event13 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    Dr. Abdullah Al-Muyeed Delivers Keynote on World Toilet Day 2025
                  </h2>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "20px 0",
                    }}
                  >
                    Date: 19 th November 2025
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    Dr. Abdullah Al-Muyeed, Chief Operating Officer of the CWIS-FSM Support Cell at the
Department of Public Health Engineering (DPHE), Bangladesh, delivered the keynote address at
the World Toilet Day 2025 event organized by Reckitt Benckiser (Bangladesh) on 19 November.
                  </p>
                 
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    In his keynote titled <strong>“The Toilet is a Mundane Marvel,”</strong>. He emphasized that a toilet is not
merely a household fixture but “the sanctuary of sanitation and hygiene,” reflecting one of the
most essential achievements of modern engineering and public health. He also highlighted that
safe sanitation remains central to protecting communities, preventing disease outbreaks, and
advancing national development—yet it is often overlooked in everyday conversations and
policy priorities.
                  </p>

                 
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    Dr. Muyeed underscored the importance of continued investment in sanitation systems, capacity
building, and behavior change initiatives to ensure that every citizen benefits from safely
managed services. He also commended Harpic Bangladesh for hosting a timely and meaningful
event that brought together stakeholders committed to improving sanitation across the country.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    The keynote served as a strong reminder that toilets, although simple in appearance, play an
extraordinary role in safeguarding health, the environment, and overall quality of life.
                  </p>
                  <Row>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height:'550px',
                            objectFit:'contain'
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news25/td1.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height:'550px',
                            objectFit:'contain'
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news25/td2.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

<br />
                  <Row>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height:'550px',
                            objectFit:'contain'
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news25/td3.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height:'550px',
                            objectFit:'contain'
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news25/td4.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event13;
